var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal-window",
    transform: "translate(-335.000000, -513.000000)",
    fill: "#B9B6C2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(327.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "modal_close_icon",
    points: "16 1.45454545 9.45454545 8 16 14.5454545 14.5454545 16 8 9.45454545 1.45454545 16 0 14.5454545 6.54545455 8 0 1.45454545 1.45454545 0 8 6.54545455 14.5454545 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.a331c2b5.svg";
export { ForwardRef as ReactComponent };